export const formWidth = {
  tablet: '325px',
};
